const GET_FIXED_PRICE_PAYMENTS_REQUEST = 'GET_FIXED_PRICE_PAYMENTS_REQUEST';
const UPDATE_FIXED_PRICE_PAYMENT_REQUEST = 'UPDATE_FIXED_PRICE_PAYMENT_REQUEST';
const DELETE_FIXED_PRICE_PAYMENT_REQUEST = 'DELETE_FIXED_PRICE_PAYMENT_REQUEST';
const CLEAR_FIXED_PRICE_PAYMENTS_REQUEST = 'CLEAR_FIXED_PRICE_PAYMENTS_REQUEST';
const GET_UNCONFIGURED_FIXED_PRICE_ENTITIES_REQUEST = 'GET_UNCONFIGURED_FIXED_PRICE_ENTITIES_REQUEST';

export const getFixedPricePayments = (callback) => ({
    type: GET_FIXED_PRICE_PAYMENTS_REQUEST,
    payload: { callback }
});

export const updateFixedPricePayment = (parentType, parentId, paymentId, body, callback) => ({
    type: UPDATE_FIXED_PRICE_PAYMENT_REQUEST,
    payload: { parentType, parentId, paymentId, body, callback }
});

export const deleteFixedPricePayment = (parentType, parentId, paymentId, callback) => ({
    type: DELETE_FIXED_PRICE_PAYMENT_REQUEST,
    payload: { parentType, parentId, paymentId, callback }
});

export const clearFixedPricePayments = (parentType, parentId, callback) => ({
    type: CLEAR_FIXED_PRICE_PAYMENTS_REQUEST,
    payload: { parentType, parentId, callback }
});

export const getUnconfiguredFixedPriceEntities = (callback) => ({
    type: GET_UNCONFIGURED_FIXED_PRICE_ENTITIES_REQUEST,
    payload: { callback }
});
